
import { defineComponent } from 'vue'

export default defineComponent({
  inheritAttrs: false,
  props: {
    name: {
      type: String
    }
  },
  setup(props, context) {
    const onClickCreateButton = () => {
      context.emit('onClickCreateButton')
    }

    return {
      onClickCreateButton
    }
  }
})
